import React, { useEffect, useState } from 'react';
import { useContent } from './content';

const STORAGE_KEY = 'alio_site_liked';

function getAbBranch(): string {
  if (typeof window === 'undefined') return 'unknown';
  return (
    window.__AB_BRANCH__ ||
    process.env.GATSBY_AB_BRANCH ||
    document.querySelector('meta[name="ab-branch"]')?.getAttribute('content') ||
    'unknown'
  );
}

function trackSiteLike() {
  if (typeof window === 'undefined') return;
  const gtag = window.gtag;
  if (typeof gtag !== 'function') return;
  gtag('event', 'site_like', {
    ab_branch: getAbBranch(),
    page_path: window.location.pathname || '/',
  });
}

const LikeSite: React.FC = () => {
  const { likeSite } = useContent();
  const [liked, setLiked] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    try {
      setLiked(window.localStorage.getItem(STORAGE_KEY) === '1');
    } catch {
      // ignore private-mode / blocked storage
    }
    setReady(true);
  }, []);

  const onLike = () => {
    if (liked) return;
    trackSiteLike();
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // still show thanks even if storage fails
    }
    setLiked(true);
  };

  if (!ready) return null;

  return (
    <div className={`like-site${liked ? ' like-site--done' : ''}`}>
      {liked ? (
        <span className="like-site__thanks" role="status">
          {likeSite.thanks}
        </span>
      ) : (
        <button type="button" className="like-site__btn" onClick={onLike} aria-label={likeSite.prompt}>
          <span className="like-site__mark" aria-hidden="true">
            ♥
          </span>
          <span className="like-site__label">{likeSite.prompt}</span>
        </button>
      )}
    </div>
  );
};

export default LikeSite;
